import {Button} from "primereact/button";
import {Message} from "primereact/message";
import {useTranslation} from "react-i18next";

import {TitledErrorMessage} from "../component/I18nErrorMessage";
import {useCheckPermissionAdmin} from "../hooks/permissionHooks";
import {useRevaOrderTypeLock} from "../hooks/valueOrderEntitlementsHooks";
import {performLogout} from "../redux/loginThunk";
import {useRevaDispatch} from "../redux/revaHooks";
import HeaderStub from "./HeaderStub";

/**
 * Fehlerseite anstelle der App, wenn beim ValueAG-Auftraggeber der eigenen Lizenz die Auftragsart REVA nicht
 * freigeschaltet ist: ohne sie legt reva-rest keine REVA-IDs an. Angezeigt von `AppContainer`.
 */
export function RevaOrderTypeNotEnabledPage() {
    const {t} = useTranslation();
    const dispatch = useRevaDispatch();
    return (
        <>
            <HeaderStub />
            <div className="MainView grow shrink-0">
                <div className="flex flex-row w-full h-full">
                    <div className="grow">
                        <div className="flex items-center justify-center h-full">
                            <div
                                id="revaOrderTypeNotEnabled"
                                className="bg-surface-0 dark:bg-surface-900 p-6 mt-8 shadow-2 rounded-border w-full"
                                style={{maxWidth: "60rem"}}
                            >
                                <TitledErrorMessage
                                    title={t("revaOrderTypeNotEnabled.title")}
                                    text={t("revaOrderTypeNotEnabled.text")}
                                    className="p-8"
                                >
                                    <Button
                                        label={t("revaOrderTypeNotEnabled.logout")}
                                        icon="pi pi-sign-out"
                                        className="mt-4"
                                        severity="secondary"
                                        onClick={() => void dispatch(performLogout())}
                                    />
                                </TitledErrorMessage>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

/**
 * Warnhinweis für Admins, die trotz fehlender Auftragsart REVA die App sehen (alle anderen bekommen
 * {@link RevaOrderTypeNotEnabledPage}). Ohne Admin-Recht oder mit freigeschalteter Auftragsart: nichts.
 */
export function RevaOrderTypeNotEnabledAdminWarning() {
    const {t} = useTranslation();
    const isAdmin = useCheckPermissionAdmin();
    const {notEnabled} = useRevaOrderTypeLock();
    if (!isAdmin || !notEnabled) return null;
    return (
        <Message
            id="revaOrderTypeNotEnabledAdminWarning"
            severity="warn"
            text={t("revaOrderTypeNotEnabled.adminWarning")}
            className="w-full justify-start rounded-none"
        />
    );
}
